import { action } from 'easy-peasy';
import { IActionRemoveUser } from '../types';

const removeUser: IActionRemoveUser = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeUser;
